import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hasSavedScrollPosition } from './useScrollRestoration';

const useScrollTop = (): null => {
  const location = useLocation();
  useEffect(() => {
    /* A screen that saved its own scroll offset on the way out is about to restore it (see
       useScrollRestoration). Resetting to the top here would flash the top of the list first, and
       on a cached render would win the race and discard the restore entirely. */
    if (hasSavedScrollPosition(location.pathname)) return;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

export default useScrollTop;
